import { getStoreSelfExtract2 ,selectedSelfSite,getZtOrder,batchVerification} from "@/libs/api.js";
import { browser } from "@/libs/common.js";
import orderItem from './orderItem.vue'
export default {
  name: "signScan",
  components: {
    orderItem
  },
  data() {
    return {
      result: [],
      checked: false,
      hasSelf:false,
      currentSiteName:'请选择',
      isShowSelfList: false,
      selfList: [],
      query: {
        pageSize: 200,
        startIndex: 1,
        siteId: "",
        orderStatus: 5,
        batchVerification:'1'
      },
      loading: false,
      finished: true,
      finishedText: "",
      isLoad: false,
      orderListArr: [],
      orderTotal:0,
      defaultIndex:0,
      submiting:false,
      isLoading:false,
    };
  },

  mounted() {
    this.init();
    window.dsBridge.call("setNativeTitle", {
      title: document.title,
    });
  },
  methods: {
    init() {
      this.getStoreSelfExtract()
    },
    //查询自提点
    getStoreSelfExtract() {
      getStoreSelfExtract2({ clientCallType: "H5" }, "jsonCallback").then((res) => {
        if (res.returnCode === "0000") {
          this.selfList = res.data || [];
          if (res.data.length > 0) {
            this.hasSelf = true;
            let selectItem=[]
            this.selfList.forEach((item,index) => {
              item.text = item.siteName;
              if(item.selected=='1'){
                //设置默认选择索引
                this.defaultIndex=index;
                selectItem.push(item)
              }
            });
            if(selectItem.length==0){
              //没有默认选择数据时默认显示第一个
              selectItem=[this.selfList[0]];
            }
            console.log('自提点',selectItem);
            this.currentSiteName = selectItem[0].siteName;
            this.query.siteId = selectItem[0].siteId;
            this.fetch();
          } else {
            this.currentSiteName = "暂无自提点";
            this.hasSelf = false;
          }
        }
      });
    },
    // 选择自提点
    changeSite(item) {
      console.log('自提点',item);
      this.currentSiteName = item.siteName;
      this.query.siteId = item.siteId;
      this.result=[];
      this.isShowSelfList=false;
      this.selectedSelfSite(item);
      this.resetList()
    },
    resetList(){
      this.isLoad = false;
      this.orderListArr = [];
      this.query.startIndex = 1;
      this.finishedText = "";
      this.fetch();
    },
    selectedSelfSite(item){
      selectedSelfSite({ clientCallType: "H5",siteId:item.siteId }, "jsonCallback").then((res) => {
        if (res.returnCode === "0000") {
          
        }
      });
    },
    // 获取自提订单列表
    fetch() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      getZtOrder(this.query, "jsonCallback").then((res) => {
        this.loading = false;
        this.finished = false;
        this.isLoading = false;
        let pkgInfo = [];
        this.orderTotal=res.total || 0;
        if (res.returnCode === "0000") {
          // res.data=[];//测试数据
          this.$toast.clear();
          if (!res.data) {
            this.finished = true;
            this.finishedText = "";
          } else {
            this.orderListArr = this.orderListArr.concat(res.data);
            console.log("orderListArr", this.orderListArr);
            let totalPages = Math.ceil(res.total / this.query.pageSize);
            if (this.query.startIndex == totalPages) {
              this.finished = true;
              this.finishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.finished = false;
              this.query.startIndex++;
            }
          }
        } else {
          this.finished = true;
        }
      }).catch(()=>{
        this.isLoading = false;
      })
    },
    toggleAll(e) {
      if(this.checked){
        // 全部选中，并跳过禁用的复选框
        this.$refs.checkboxGroup.toggleAll({
          checked: true,
          skipDisabled: true,
        });
      }else{
        // 全部反选，并跳过禁用的复选框
        this.$refs.checkboxGroup.toggleAll(false);
      }
      console.log('===全选/反选', this.checked,this.result);
    },
    onChange(){
      console.log('===选中数据', this.result);
      if(this.result.length===this.orderListArr.length){
        this.checked=true;
      }else{
        this.checked=false;
      }
    },
    onSubmit(){
      console.log('===提交数据')
      if(this.submiting){
        return;
      }
      this.$dialog
        .confirm({
          title: "提示",
          message: `请确认当前已选中的${this.result.length}个订单需要批量核销，确认核销后状态不可恢复`,
          confirmButtonText: "确认核销",
          cancelButtonText: "取消",
          confirmButtonColor: "#FF2727",
        })
        .then(() => {
          // on confirm
          console.log("确认");
          this.submiting = true;
          batchVerification({escOrderIds:this.result.join(',')},'jsonCallback').then((res)=>{
            if(res.returnCode==='0000'){
              this.$toast('核销成功');
              this.result = [];
              setTimeout(()=>{
                this.submiting = false;
                this.resetList()
              },3000)
            }else{
              this.submiting = false;
            }
          }).catch(()=>{
            this.submiting = false;
          })
        })
        .catch(() => {    
          // on cancel
          console.log("取消");
        });
    }
  },
};
